module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "foreword",
      "id": "_idContainer000",
      "role": "doc-foreword"
    }
  }, [_c('p', {
    staticClass: "pl-fl-header"
  }, [_vm._v("“I’m going to bunk here so I can keep an eye on things...”")]), _vm._v(" "), _c('p', {
    staticClass: "pl-fl-roman"
  }, [_vm._v("Lizzie was going to sleep in the stable? On the floor?")]), _vm._v(" "), _c('p', {
    staticClass: "pl-fl-roman"
  }, [_vm._v("It felt wrong to leave her there, which was silly because Heath had spent many a night in the lambing barns. But this wasn’t him. It was Lizzie. And when she stuck a ridiculously small pillow behind her head, he wanted to snatch it, send her to bed and say he’d watch the horse.")]), _vm._v(" "), _c('p', {
    staticClass: "pl-fl-roman"
  }, [_vm._v("She gazed up at him, looking so much like the girl she’d been twelve years before. But different, too.")]), _vm._v(" "), _c('p', {
    staticClass: "pl-fl-roman"
  }, [_vm._v("“It’s my job, Heath.” She kept her voice quiet. Matter-of-fact. And quite professional. “People don’t inherit a quarter share of a ranch worth millions without putting in some time. I’ll see you tomorrow.”")]), _vm._v(" "), _c('p', {
    staticClass: "pl-fl-roman"
  }, [_vm._v("She was right. He knew that.")]), _vm._v(" "), _c('p', {
    staticClass: "pl-fl-roman"
  }, [_vm._v("But walking away from her—moving through the door into the cold spring night—was one of the toughest things he’d done in a long time.")]), _vm._v(" "), _c('p', {
    staticClass: "pl-fl-roman"
  }, [_vm._v("He did it because it was the right thing to do. But he hated every minute of it.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7537d72c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Introduction.vue
// module id = 60
// module chunks = 0